//@flow
import { asyncComponent } from 'react-async-component'
import LoadingComponent from '../../LoadingComponent'
import ErrorComponent from '../../ErrorComponent'

export default asyncComponent({
  resolve: () => import('./HotspotGroup'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncHotspotGroup',
})



// WEBPACK FOOTER //
// ./src/components/QuestionElements/HotspotGroup/index.js